import { useFormikContext } from 'formik';
import { OfferType, PromoterDiscountType } from 'legacy/events/types';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import PromoterDiscountCodeForm from '../PromoterDiscountCodeForm';
import PromoterDiscountCard from '../PromoterDiscountCard';

const PromoterDiscount = ({ eventId }: { eventId: string }) => {
  const { t } = useTranslation('events');
  const { values, setFieldValue } = useFormikContext<OfferType>();
  const [shouldShowCreateForm, setShouldShowCreateForm] = useState(false);
  const promoterDiscount = values.discount;
  const hasActiveContract = values.contracts?.length > 0;

  const handleCreateDiscountCode = (discountCode) => {
    setShouldShowCreateForm(false);
    const promoterDiscount: PromoterDiscountType = {
      value: discountCode.value,
      kind: discountCode.kind as 'amount' | 'percentage',
      usageLimitPerContract: discountCode.maxUsage,
      startDate: discountCode.startDate,
      endDate: discountCode.endDate
    };
    setFieldValue('discount', promoterDiscount);
  };

  const handleCloseCreateForm = () => {
    setShouldShowCreateForm(false);
  };

  return (
    <div>
      {!promoterDiscount ? (
        <div
          className="text-sm font-bold text-[#3853C4] cursor-pointer mt-4"
          onClick={() => !hasActiveContract && setShouldShowCreateForm(true)}
          style={{
            opacity: hasActiveContract ? 0.5 : 1,
            cursor: hasActiveContract ? 'not-allowed' : 'pointer'
          }}
        >
          {t('settings.promoterOffers.advanceOptions.setPurchaserDiscount')}
        </div>
      ) : (
        <PromoterDiscountCard
          setShouldShowCreateForm={setShouldShowCreateForm}
        />
      )}
      {shouldShowCreateForm && (
        <PromoterDiscountCodeForm
          eventId={eventId}
          onSubmit={handleCreateDiscountCode}
          onClose={handleCloseCreateForm}
          initialValues={promoterDiscount}
        />
      )}
    </div>
  );
};

export default PromoterDiscount;
